const colorSchemes = {
    esriPink3: '#feebe2ff,#fcc5c0ff,#fa9fb5ff,#f768a1ff,#c51b8aff,#7a0177ff',
    esriBlue4: '#f0f9e8ff,#ccebc5ff,#a8ddb5ff,#7bccc4ff,#43a2caff,#0868acff',
    esriGreen3: '#f6eff7ff,#d0d1e6ff,#a6bddbff,#67a9cfff,#1c9099ff,#016c59ff'
};
colorSchemes.pinkSeven = '#ffffff,#d1d1d1,,' + colorSchemes.esriPink3;
colorSchemes.pinkEight = '#ffffff,#d1d1d1,#808080,' + colorSchemes.esriPink3;
colorSchemes.blueSeven = '#ffffff,#d1d1d1,,' + colorSchemes.esriBlue4;
colorSchemes.blueEight = '#ffffff,#d1d1d1,#808080,' + colorSchemes.esriBlue4;
colorSchemes.greenSeven = '#ffffff,#d1d1d1,,' + colorSchemes.esriGreen3;
colorSchemes.greenEight = '#ffffff,#d1d1d1,#808080,' + colorSchemes.esriGreen3;
colorSchemes.pinkState = '#ffffff,#d1d1d1,#808080,#feebe2ff,#fbb4b9ff,#f768a1ff,#c51b8aff,#7a0177ff,';
colorSchemes.greenState = '#ffffff,#d1d1d1,#808080,#f6eff7ff,#bdc9e1ff,#67a9cfff,#1c9099ff,#016c59ff,';

const colors = {};

Object.keys(colorSchemes).forEach((key) => {
    colors[key] = colorSchemes[key].split(',');
});

const values = {};

values.eight = [
    { name: 'outofscope', val: -777 }, //there is not -777
    { name: 'na', val: -888 },
    { name: 'unstable', val: -999 },
    { name: 'none', val: 0 },
    { name: 'lowest', val: 1 },
    { name: 'low', val: 2 },
    { name: 'med', val: 3 },
    { name: 'high', val: 4 },
    { name: 'highest', val: 5 }
];

const labels = {
    rate_usstate: [null, 'Data Unavailable', 'Unstable\nRate', '0', '0.1 - 25th percentile', '25.1 – 50th percentile', '50.1 - 75th percentile', '75.1 - 100th percentile', null],
    rate_county: [null, 'Data Unavailable', 'Unstable\nRate', '0', '0.1 - 25th percentile', '25.1 – 50th percentile', '50.1 - 75th percentile', '75.1 - 95th percentile', '95.1 - 100th percentile'],
    rate_census: [null, 'Data Unavailable', 'Unstable\nRate', '0', '0.1 - 25th percentile', '25.1 – 50th percentile', '50.1 - 75th percentile', '75.1 - 95th percentile', '95.1 - 100th percentile'],
    rate_zcta: ['ZIP Code Unavailable', 'Data Unavailable', 'Unstable\nRate', '0', '0.1 - 25th percentile', '25.1 – 50th percentile', '50.1 - 75th percentile', '75.1 - 95th percentile', '95.1 - 100th percentile'],
    count_usstate: [null, 'Data Unavailable', null, '0', '1-100', '101-250', '251-500', '501-1,500', '≥1,501'],
    count_county: [null, 'Data Unavailable', null, '0', '1-9', '10-50', '51-100', '101-250', '≥251'],
    count_census: [null, 'Data Unavailable', null, '0', '1-9', '10-15', '16-20', '21-25', '≥26'],
    count_zcta: ['ZIP Code Unavailable', 'Data Unavailable', null, '0', '1-9', '10-15', '16-20', '21-25', '≥26']
};

// const rawSymbology = {
//     census: {
//         rate_sym_ed: { colors: colors.pinkEight, labels: labels.rate_census },
//         rate_sym_all: { colors: colors.greenEight, labels: labels.rate_census },
//         rate_sym_homicide: { colors: colors.greenEight, labels: labels.rate_census },
//         rate_sym_suicide: { colors: colors.greenEight, labels: labels.rate_census },
//         count_sym_all: { colors: colors.blueSeven, labels: labels.count_census },
//         count_sym_homicide: { colors: colors.blueSeven, labels: labels.count_census },
//         count_sym_suicide: { colors: colors.blueSeven, labels: labels.count_census }
//     },
//     zcta: {
//         rate_sym_ed: { colors: colors.pinkEight, labels: labels.rate_zcta },
//         rate_sym_all: { colors: colors.greenEight, labels: labels.rate_zcta },
//         rate_sym_homicide: { colors: colors.greenEight, labels: labels.rate_zcta },
//         rate_sym_suicide: { colors: colors.greenEight, labels: labels.rate_zcta },
//         count_sym_all: { colors: colors.blueSeven, labels: labels.count_zcta },
//         count_sym_homicide: { colors: colors.blueSeven, labels: labels.count_zcta },
//         count_sym_suicide: { colors: colors.blueSeven, labels: labels.count_zcta }
//     }
// };

const rawSymbology = {
    usstate: {
        //endpoint 2
        rate_sym_ed: { colors: colors.pinkState, labels: labels.rate_usstate },
        rate_sym_all: { colors: colors.greenState, labels: labels.rate_usstate },
        rate_sym_homicide: { colors: colors.greenState, labels: labels.rate_usstate },
        rate_sym_suicide: { colors: colors.greenState, labels: labels.rate_usstate },
        count_sym_all: { colors: colors.blueSeven, labels: labels.count_usstate },
        count_sym_homicide: { colors: colors.blueSeven, labels: labels.count_usstate },
        count_sym_suicide: { colors: colors.blueSeven, labels: labels.count_usstate },
        //endpoint 3
        rate_sym_drug_od: { colors: colors.greenState, labels: labels.rate_usstate },
        rate_sym_fa_deaths: { colors: colors.greenState, labels: labels.rate_usstate },
        rate_sym_all_homicide: { colors: colors.greenState, labels: labels.rate_usstate },
        rate_sym_fa_homicide: { colors: colors.greenState, labels: labels.rate_usstate },
        rate_sym_all_suicide: { colors: colors.greenState, labels: labels.rate_usstate },
        rate_sym_fa_suicide: { colors: colors.greenState, labels: labels.rate_usstate },
        count_sym_drug_od: { colors: colors.blueSeven, labels: labels.count_usstate },
        count_sym_fa_deaths: { colors: colors.blueSeven, labels: labels.count_usstate },
        count_sym_all_homicide: { colors: colors.blueSeven, labels: labels.count_usstate },
        count_sym_fa_homicide: { colors: colors.blueSeven, labels: labels.count_usstate },
        count_sym_all_suicide: { colors: colors.blueSeven, labels: labels.count_usstate },
        count_sym_fa_suicide: { colors: colors.blueSeven, labels: labels.count_usstate }
    },
    county: {
        //endpoint 2
        rate_sym_ed: { colors: colors.pinkEight, labels: labels.rate_county },
        rate_sym_all: { colors: colors.greenEight, labels: labels.rate_county },
        rate_sym_homicide: { colors: colors.greenEight, labels: labels.rate_county },
        rate_sym_suicide: { colors: colors.greenEight, labels: labels.rate_county },
        count_sym_all: { colors: colors.blueSeven, labels: labels.count_county },
        count_sym_homicide: { colors: colors.blueSeven, labels: labels.count_county },
        count_sym_suicide: { colors: colors.blueSeven, labels: labels.count_county },
        //endpoint 3
        rate_sym_drug_od: { colors: colors.greenEight, labels: labels.rate_county },
        rate_sym_fa_deaths: { colors: colors.greenEight, labels: labels.rate_county },
        rate_sym_all_homicide: { colors: colors.greenEight, labels: labels.rate_county },
        rate_sym_fa_homicide: { colors: colors.greenEight, labels: labels.rate_county },
        rate_sym_all_suicide: { colors: colors.greenEight, labels: labels.rate_county },
        rate_sym_fa_suicide: { colors: colors.greenEight, labels: labels.rate_county },
        count_sym_drug_od: { colors: colors.blueSeven, labels: labels.count_county },
        count_sym_fa_deaths: { colors: colors.blueSeven, labels: labels.count_county },
        count_sym_all_homicide: { colors: colors.blueSeven, labels: labels.count_county },
        count_sym_fa_homicide: { colors: colors.blueSeven, labels: labels.count_county },
        count_sym_all_suicide: { colors: colors.blueSeven, labels: labels.count_county },
        count_sym_fa_suicide: { colors: colors.blueSeven, labels: labels.count_county }
    },
    census: {
        //endpoint 2
        rate_sym_ed: { colors: colors.pinkEight, labels: labels.rate_census },
        rate_sym_all: { colors: colors.greenEight, labels: labels.rate_census },
        rate_sym_homicide: { colors: colors.greenEight, labels: labels.rate_census },
        rate_sym_suicide: { colors: colors.greenEight, labels: labels.rate_census },
        count_sym_all: { colors: colors.blueSeven, labels: labels.count_census },
        count_sym_homicide: { colors: colors.blueSeven, labels: labels.count_census },
        count_sym_suicide: { colors: colors.blueSeven, labels: labels.count_census },
        //endpoint 3
        rate_sym_drug_od: { colors: colors.greenEight, labels: labels.rate_census },
        rate_sym_fa_deaths: { colors: colors.greenEight, labels: labels.rate_census },
        rate_sym_all_homicide: { colors: colors.greenEight, labels: labels.rate_census },
        rate_sym_fa_homicide: { colors: colors.greenEight, labels: labels.rate_census },
        rate_sym_all_suicide: { colors: colors.greenEight, labels: labels.rate_census },
        rate_sym_fa_suicide: { colors: colors.greenEight, labels: labels.rate_census },
        count_sym_drug_od: { colors: colors.blueSeven, labels: labels.count_census },
        count_sym_fa_deaths: { colors: colors.blueSeven, labels: labels.count_census },
        count_sym_all_homicide: { colors: colors.blueSeven, labels: labels.count_census },
        count_sym_fa_homicide: { colors: colors.blueSeven, labels: labels.count_census },
        count_sym_all_suicide: { colors: colors.blueSeven, labels: labels.count_census },
        count_sym_fa_suicide: { colors: colors.blueSeven, labels: labels.count_census }
    },
    zcta: {
        //endpoint 2
        rate_sym_ed: { colors: colors.pinkEight, labels: labels.rate_zcta },
        rate_sym_all: { colors: colors.greenEight, labels: labels.rate_zcta },
        rate_sym_homicide: { colors: colors.greenEight, labels: labels.rate_zcta },
        rate_sym_suicide: { colors: colors.greenEight, labels: labels.rate_zcta },
        count_sym_all: { colors: colors.blueSeven, labels: labels.count_zcta },
        count_sym_homicide: { colors: colors.blueSeven, labels: labels.count_zcta },
        count_sym_suicide: { colors: colors.blueSeven, labels: labels.count_zcta },
        //endpoint 3
        rate_sym_drug_od: { colors: colors.greenEight, labels: labels.rate_zcta },
        rate_sym_fa_deaths: { colors: colors.greenEight, labels: labels.rate_zcta },
        rate_sym_all_homicide: { colors: colors.greenEight, labels: labels.rate_zcta },
        rate_sym_fa_homicide: { colors: colors.greenEight, labels: labels.rate_zcta },
        rate_sym_all_suicide: { colors: colors.greenEight, labels: labels.rate_zcta },
        rate_sym_fa_suicide: { colors: colors.greenEight, labels: labels.rate_zcta },
        count_sym_drug_od: { colors: colors.blueSeven, labels: labels.count_zcta },
        count_sym_fa_deaths: { colors: colors.blueSeven, labels: labels.count_zcta },
        count_sym_all_homicide: { colors: colors.blueSeven, labels: labels.count_zcta },
        count_sym_fa_homicide: { colors: colors.blueSeven, labels: labels.count_zcta },
        count_sym_all_suicide: { colors: colors.blueSeven, labels: labels.count_zcta },
        count_sym_fa_suicide: { colors: colors.blueSeven, labels: labels.count_zcta }
    }
};
const symbology = {};

//Parse raw symbology
Object.keys(rawSymbology).forEach((scale) => {
    symbology[scale] = {};
    Object.keys(rawSymbology[scale]).forEach((attr) => {
        const srcObj = rawSymbology[scale][attr];
        symbology[scale][attr] = [];
        for (var i = 0; i < srcObj.colors.length; i++) {
            let color = srcObj.colors[i];
            let step = values.eight[i];
            let label = srcObj.labels[i];
            symbology[scale][attr].push(Object.assign({}, step, { color, label }));
        }
    });
});

export { symbology };
